import { GradeHistoryItem } from "../types/grading";

const USER_ID_KEY = "cg_user_id";
const HISTORY_KEY = "cg_history";
const LAST_RESULT_KEY = "cg_last_result";

export function getOrCreateUserId(): string {
  const existing = localStorage.getItem(USER_ID_KEY);
  if (existing) return existing;
  const created =
    typeof crypto !== "undefined" && "randomUUID" in crypto
      ? crypto.randomUUID()
      : `user_${Date.now()}_${Math.random().toString(16).slice(2)}`;
  localStorage.setItem(USER_ID_KEY, created);
  return created;
}

export function readHistory(): GradeHistoryItem[] {
  const raw = localStorage.getItem(HISTORY_KEY);
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw) as GradeHistoryItem[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function writeHistory(items: GradeHistoryItem[]) {
  localStorage.setItem(HISTORY_KEY, JSON.stringify(items));
}

export function addToHistory(item: GradeHistoryItem) {
  const next = [item, ...readHistory()];
  writeHistory(next);
}

export function writeLastResult(item: GradeHistoryItem) {
  localStorage.setItem(LAST_RESULT_KEY, JSON.stringify(item));
}

export function readLastResult(): GradeHistoryItem | null {
  const raw = localStorage.getItem(LAST_RESULT_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as GradeHistoryItem;
  } catch {
    return null;
  }
}

